import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import Common from './js/common';
import Request from './js/request';
import Global from './js/global';
import store from "./store";
import Config from "./config";
import Loading from './components/loading';

Vue.prototype.$http = Request;
Vue.prototype.$cjs = Common;
Vue.prototype.$global = Global;
Vue.prototype.$hub = new Vue();

Vue.component('loading', Loading);

let app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

window.VueApp = app;
